import GoogleMapsLoader from 'google-maps'
import { find } from '../common/elements'
import __ from '../../react/utils/i18n'
import MarkerClusterer from '@google/markerclusterer'

GoogleMapsLoader.KEY = __('__google_maps_javascript_api_key__')
GoogleMapsLoader.LANGUAGE = 'de'

const mapOptions = {
  scrollwheel: false,
  zoom: 14,
  navigationControl: true,
  mapTypeControl: false,
  scaleControl: true,
  disableDefaultUI: true,
  center: {
    lat: 40.724462,
    lng: -73.995388,
  },
}

const Map = () => {
  let _map
  let markerClusterer
  let markers = []

  const addMarker = (map, marker, google) =>
    new google['maps']['Marker']({
      position: {
        lat: marker.lat,
        lng: marker.lng,
      },
      map,
      title: marker.title,
    })

  const elementMap = el => {
    let mapCenter = el.getAttribute('data-map-pin')
    const address = el.getAttribute('data-map-address')
    const jsApiKey = el.getAttribute('data-map-js-api-key')

    if (mapCenter) mapCenter = mapCenter.split(',')

    if (jsApiKey && !GoogleMapsLoader.KEY) GoogleMapsLoader.KEY = jsApiKey

    if (!mapCenter && !address) return

    GoogleMapsLoader.load(google => {
      const p = new Promise((resolve, reject) => {
        if (mapCenter.length === 2 && mapCenter[0] && mapCenter[1]) {
          mapOptions.center = {
            lat: parseFloat(mapCenter[0]),
            lng: parseFloat(mapCenter[1]),
          }
          drawMap(resolve, el)
        } else {
          if (!address) reject('Please specify an address')
          console.log(`no coordinates given trying to find: ${address}`)

          new google['maps']['Geocoder']()['geocode'](
            { address },
            (results, status) => {
              if (status === google['maps']['GeocoderStatus']['OK']) {
                console.log('setting map coordinats')
                mapOptions.center = {
                  lat: parseFloat(results[0]['geometry']['location'].lat()),
                  lng: parseFloat(results[0]['geometry']['location'].lng()),
                }
                // resolve(mapOptions)
                drawMap(resolve, el)
              } else {
                el.parentElement.remove()
                reject('No Coordinates found for given address.')
              }
            }
          )
        }
      })
    })
  }

  const drawMap = (resolve, el) => {
    _map = new google['maps'].Map(el, mapOptions)

    const infowindow = new google['maps']['InfoWindow']()
    const marker = addMarker(
      _map,
      {
        lat: parseFloat(mapOptions.center.lat),
        lng: parseFloat(mapOptions.center.lng),
        title: '',
      },
      google
    )
    const company = el.getAttribute('data-map-company')
    const address = el.getAttribute('data-map-address')
    const phone = el.getAttribute('data-map-phone')
    let email = el.getAttribute('data-map-email')
    let website = el.getAttribute('data-map-website')

    let infoWindowContent = `<div>
              <strong>${company}</strong><br />
              ${address}<br />
              ${phone || ''}
            </div>`

    if (email)
      infoWindowContent += `<br /><a href="mailto:${email}">${email}</a>`

    if (website)
      infoWindowContent += `<br /><a href="${website}" target="_blank">${website}</a>`

    infowindow['setContent'](infoWindowContent)

    marker.addListener('click', () => {
      infowindow.open(_map, marker)
    })
    resolve(_map)
  }

  const createMap = (el, options, data = []) => {
    GoogleMapsLoader.load(google => {
      _map = new google['maps'].Map(el, {...mapOptions, options})

      if (data.length > 0) {
        updateMap(_map, data)
      }
    })
  }

  const updateMap = (map, data) => {
    let bounds = createBounds()

    markers.map( e => { e.setMap( null ); } );

    markers = [];

    markerClusterer && markerClusterer.clearMarkers()

    for (let i = 0; i < data.length; i++) {
      let item = data[i]

      if (item.coordinates) {
        markers.push(
          createMarker(
            map,
            {
              map,
              position: item.coordinates,
              title: item.title,
            },
            (item.permalink ? "<a href='" + item.permalink + "'>" : "") +
              "<div class='wwp3-search__map_info_window_title'>" + item.title + "</div>" +
              (item.image ? "<div class='wwp3-search__map_info_window_image'><img src='" + item.image + "' alt=''/></div>" : "") +
              (item.description ? "<div class='wwp3-search__map_info_window_description'>" + item.description + "</div>" : "") +
            (item.permalink ? "</a>" : "")
          )
        )
        bounds.extend(item.coordinates)
      }
    }

    if (markers.length) {
      if (markers.length === 1) {
        zoomAndPan(map, 15, markers[0].position)
        markers[0].showInfoWindow()
      } else {
        markerClusterer = createMarkerClusterer(map, markers)
        fitBounds(map, bounds, 20)
      }
    }
  }

  const createMarker = (map, options, infoWindowContent) => {
    const marker = new google['maps']['Marker'](options)

    if (infoWindowContent) {
      const infowindow = new google['maps']['InfoWindow']({
        content: infoWindowContent,
      })

      marker.showInfoWindow = () => {
        infowindow.open(map, marker)
      }

      marker.addListener('click', () => {
        infowindow.open(map, marker)
      })
    }

    return marker
  }

  const fitBounds = (map, bounds, padding) => {
    map.fitBounds(bounds, padding)
  }

  const createBounds = () => {
    return new google['maps']['LatLngBounds']()
  }

  const createMarkerClusterer = (map, markers) => {
    return new MarkerClusterer(map, markers, {
      maxZoom: 17,
      imagePath: window.wwp3['imgUrl'] + 'map/cluster',
    })
  }

  const zoomAndPan = (map, zoom = null, position = null) => {
    // zoom && map['setZoom'](zoom)
    position && map['panTo'](position)
  }

  const getMap = () => _map

  const init = () => {
    const mapElements = find('.wwp3-js-map')
    const mapElementsCount = mapElements.length

    for (let i = 0; i < mapElementsCount; i += 1) elementMap(mapElements[i])
  }

  init()

  return {
    createMap,
    updateMap,
    getMap,
    // createMarker,
    // fitBounds,
    // createBounds,
    // createMarkerClusterer,
    // zoomAndPan,
  }
}

export default Map



// WEBPACK FOOTER //
// src/assets/js/front-end/components/map.js